module.exports = __webpack_public_path__ + "img/dd3.093f0096.jpg";